import React from 'react';
import { I18nProvider } from '@react-aria/i18n';
export function LocaleContext({ locale, children }) {
    return React.createElement(I18nProvider, { locale: locale }, children);
}
